<template>
  <div>
    <div class="table-content row-data">
      <el-table
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          :data="tableData"
          highlight-current-row
          :header-cell-style="tableHeaderColor"
          max-height="700px"
          style="width: 1000px"
          border
      >
        <el-table-column
            align="center"
            prop="index"
            label="STT"
            width="100">
        </el-table-column>
        <el-table-column
            prop="name"
            label="Tên chức năng"
            width="700">
        </el-table-column>
        <el-table-column
            label="Tác vụ"
            align="center"
        >
          <template slot-scope="scope">
            <el-button
                :loading="scope.row.loading"
                size="mini"
                type="primary"
                @click="handleAction(scope.row)"
            >{{ scope.row.nameButton }}
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <CreateAttendanceEvaluateDialog
          :showCreateAttendanceEvaluateDialog = showCreateAttendanceEvaluateDialog
          :schoolList = schoolList
          @close = "closeCreateAttendanceEvaluateDialog"
      />
      <CreateEvaluateWeekMonthDialog
          :showCreateEvaluateWeekMonthDialog = showCreateEvaluateWeekMonthDialog
          :schoolList = schoolList
          @close = "closeCreateEvaluateWeekMonthDialog"
      />
      <DeleteAttendanceDuplicateDialog
          :showDeleteAttendanceDuplicateDialog = showDeleteAttendanceDuplicateDialog
          @close = "closeDeleteAttendanceDuplicateDialog"
      />
      <CreateQRCodeDialog
          :showCreateQRCodeDialog = showCreateQRCodeDialog
          :schoolList = schoolList
          @close = "closeCreateQRCodeDialog"
      />
      <CreateCashBookDialog
      :showCreateCashBookDialog = showCreateCashBookDialog
      :schoolList = schoolList
      @close = "closeCreateCashBookDialog"
      />
      <CreateDayOffDialog
          :showCreateDayOffDialog = showCreateDayOffDialog
          @close = "closeCreateDayOffDialog"
      />
    </div>
  </div>
</template>

<script>
import OtherService from "@/services/CommonService/OtherService";
import SchoolConfigService from "@/services/SchoolService/SchoolConfigService";
import CreateAttendanceEvaluateDialog from "@/views/master/other/CreateAttendanceEvaluateDialog.vue";
import CreateEvaluateWeekMonthDialog from "@/views/master/other/CreateEvaluateWeekMonthDialog.vue";
import DeleteAttendanceDuplicateDialog from "@/views/master/other/DeleteAttendanceDuplicateDialog.vue";
import CreateQRCodeDialog from "@/views/master/other/CreateQRCodeDialog.vue";
import CreateCashBookDialog from "@/views/master/other/CreateCashBookDialog.vue";
import CreateDayOffDialog from "@/views/master/other/CreateDayOffDialog.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  components: {
    CreateDayOffDialog,
    CreateCashBookDialog,
    CreateQRCodeDialog,
    DeleteAttendanceDuplicateDialog, CreateEvaluateWeekMonthDialog, CreateAttendanceEvaluateDialog},
  data() {
    return {
      tableData: [
        {
          index: '1',
          name: 'Tạo dữ liệu chung cho hệ thống',
          nameButton: 'Tạo dữ liệu',
          loading: false
        },
        {
          index: '2',
          name: "Tạo folder '0' cho hệ thống",
          nameButton: 'Tạo folder',
          loading: false,
        },
        {
          index: '3',
          name: "Kiểm tra backend",
          nameButton: 'Kiểm tra',
          loading: false
        },
        {
          index: '4',
          name: "Tạo điểm danh/nhận xét",
          nameButton: 'Khởi tạo',
          loading: false
        },
        {
          index: '5',
          name: "Tạo nhận xét tuần/tháng",
          nameButton: 'Khởi tạo',
          loading: false
        },
        {
          index: '6',
          name: "Xóa dữ liệu trùng",
          nameButton: 'Truy cập',
          loading: false
        },
        {
          index: '7',
          name: "Xóa token Firebase trùng",
          nameButton: 'Tiến hành xóa',
          loading: false
        },
        {
          index: '8',
          name: "Tạo mã QR Code",
          nameButton: 'Khởi tạo',
          loading: false
        },
        {
          index: '9',
          name: "Tạo ví cho trường",
          nameButton: 'Khởi tạo',
          loading: false
        },
        {
          index: '10',
          name: "Tạo ngày nghỉ chủ nhật cho các lớp",
          nameButton: 'Khởi tạo',
          loading: false
        },
        {
          index: '11',
          name: "Tạo bộ đếm số lượng giao dịch thanh toán trực tuyến cho năm hiện tại ",
          nameButton: 'Khởi tạo',
          loading: false
        },
        {
          index: '12',
          name: "Tạo token thanh toán trực tuyến",
          nameButton: 'Khởi tạo',
          loading: false
        },

      ],
      showCreateAttendanceEvaluateDialog: false,
      showCreateEvaluateWeekMonthDialog: false,
      showDeleteAttendanceDuplicateDialog: false,
      showCreateQRCodeDialog: false,
      showCreateCashBookDialog: false,
      showCreateDayOffDialog: false,
      nameDelete: "Tiến hành xóa",
      dataBackend: "",
      dataInput: {
        date: "",
        idSchool: "",
      },
      dataInput1: {
        date: "",
      },
      dataInput2: {
        dateWeek: "",
        dateMonth: "",
        idSchool: "",
      },
      dataInput3: {
        date: "",
        idSchool: "",
      },
      schoolList: [],
    };
  },
  methods: {
    handleAction(row) {
      switch (row.index) {
        case '1':
          this.createDataCommonMethod(row);
          break;
        case '2':
          this.createFolderSystemMethod(row);
          break;
        case '3':
          this.checkBackendMethod(row);
          break;
        case '4':
          this.openCreateAttendanceEvaluateDialog();
          break;
        case '5':
          this.openCreateEvaluateWeekMonthDialog();
          break;
        case '6':
          this.openDeleteAttendanceDuplicateDialog();
          break;
        case '7':
          this.deleteTokenFirebase(row);
          break;
        case '8':
          this.openCreateQRCodeDialog();
          break;
        case '9':
          this.openCreateCashBookDialog();
          break;
        case '10':
          this.openCreateDayOffDialog();
          break;
        case '11':
          this.createGenerateDaysForCurrentYearIfNotExist();
          break;
        case '12':
          this.createTokenOnlinePayment();
          break;
      }
    },
    createDataCommonMethod(row) {
      row.loading = true
      OtherService.createDataSystem()
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
            row.loading = false
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            row.loading = false
          });
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    createFolderSystemMethod(row) {
      row.loading = true
      OtherService.createFolderSystem()
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
            row.loading = false
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            row.loading = false
          });
    },
    checkBackendMethod(row) {
      row.loading = true
      OtherService.checkBackend()
          .then((resp) => {
            this.dataBackend = resp.data;
            this.$message({
              message: "Cổng đang khởi chạy: " + this.dataBackend,
              type: "success",
            });
            row.loading = false
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            row.loading = false
          });
    },
    deleteTokenFirebase(row) {
      this.$confirm("Bạn có chắc chắn muốn xóa không?", "Cảnh báo!", {
        confirmButtonText: "Có",
        cancelButtonText: "Không",
        type: "warning"
      }).then((resp) => {
        row.loading = true
        SchoolConfigService.deleteTokenFireBaseDuplicate().then(() => {
          this.$message({
            message: "Xóa thành công!",
            type: "success",
          });
          console.log(resp)
        }).catch((err) => {
          this.$message({
            message: "Thất bại",
            type: "error",
          });
          console.log(err)
        }).finally(() => {
          row.loading = false
        })
      })
    },
    async createTokenOnlinePayment(){
      await sePayConnectionService.createTokenSePayConnectionV2().then((response) => {
        if (response.data.status === 200) {
          NotifyMessage.leftCornerNotificationSuccess("Khởi tạo thành công!")
        }
      }).catch((err) => {
        console.log(err)
        NotifyMessage.leftCornerNotificationError("Khởi tạo thất bại!")
      })
    },
    getAllSchoolMethod() {
      OtherService.getSchoolAllService()
          .then((resp) => {
            this.schoolList = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    async createGenerateDaysForCurrentYearIfNotExist(){
      await sePayConnectionService.generateDaysForCurrentYearIfNotExist().then(() => {
        NotifyMessage.leftCornerNotificationSuccess("Khởi tạo thành công!")
      }).catch((err) => {
        console.log(err)
        NotifyMessage.leftCornerNotificationError("Khởi tạo thất bại!")
      })
    },
    openCreateAttendanceEvaluateDialog () {
      this.showCreateAttendanceEvaluateDialog = true
    },
    closeCreateAttendanceEvaluateDialog(value) {
      this.showCreateAttendanceEvaluateDialog = value;
    },

    openCreateEvaluateWeekMonthDialog () {
      this.showCreateEvaluateWeekMonthDialog = true
    },
    closeCreateEvaluateWeekMonthDialog(value) {
      this.showCreateEvaluateWeekMonthDialog = value;
    },
    openDeleteAttendanceDuplicateDialog () {
      this.showDeleteAttendanceDuplicateDialog = true
    },
    closeDeleteAttendanceDuplicateDialog(value) {
      this.showDeleteAttendanceDuplicateDialog = value;
    },
    openCreateQRCodeDialog () {
      this.showCreateQRCodeDialog = true
    },
    closeCreateQRCodeDialog(value) {
      this.showCreateQRCodeDialog = value;
    },
    openCreateCashBookDialog () {
      this.showCreateCashBookDialog = true
    },
    closeCreateCashBookDialog(value) {
      this.showCreateCashBookDialog = value;
    },
    openCreateDayOffDialog () {
      this.showCreateDayOffDialog = true
    },
    closeCreateDayOffDialog(value) {
      this.showCreateDayOffDialog = value;
    },

  },
  beforeMount() {
    this.getAllSchoolMethod();
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
